import { useQuery } from "@tanstack/react-query";
import { fetchGamificationUserRankList } from "../services/gamificationService";

function normalizePlayer(item = {}, index = 0) {
  return {
    rank: Number(item?.rank || index + 1),
    studentId: Number(item?.user_id || 0),
    name: item?.user_name || "Student",
    avatar: item?.profile_pics || "",
    score: Number(item?.total_points || 0),
    totalTime: Number(item?.total_time_taken || 0),
    totalTimeFormatted: item?.total_time_taken || "00:00",
  };
}

export function useGamificationBattleLeaderboard(params = {}, options = {}) {
  return useQuery({
    queryKey: ["gamificationBattleLeaderboard", params],
    queryFn: async () => {
      const { payload } = await fetchGamificationUserRankList({
        type: "all",
        ...params,
      });

      const players = (Array.isArray(payload?.users_list) ? payload.users_list : []).map(normalizePlayer);

      return {
        roomCode: payload?.room_code || "",
        topThree: players.slice(0, 3),
        players,
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
